/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Detail_Holdings_HintInputs */



/**
* | output |
* | --- |
* | "Shared spaces and projects only — personal ones are never shown." |
*
* @param {Member_Detail_Holdings_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_holdings_hint = /** @type {((inputs?: Member_Detail_Holdings_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Holdings_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur geteilte Spaces und Projekte — persönliche werden nie angezeigt.")
	return /** @type {LocalizedString} */ ("Shared spaces and projects only — personal ones are never shown.")
});